import { Feature } from 'src/types/features.types';

export const getNewFeaturesToasterId = (feature: Feature) => {
  return `new-features-${feature}`;
};
